import store from '@/store';
import { RouteRecordRaw } from 'vue-router';

export default (): Array<RouteRecordRaw> => {
    return [
        {
            path: '/admin',
            name: 'admin',
            component: () => import('./views/admin.vue'),
        },
        {
            path: '/syncConfigs',
            name: 'syncConfigs',
            component: () => import('./views/syncConfigs.vue'),
        },
        {
            path: '/syncConfigs/:identifier',
            name: 'syncConfigsDetail',
            component: () => import('./views/syncConfigsDetail.vue'),
        },
        {
            path: '/syncStates',
            name: 'syncStates',
            component: () => import('./views/syncStates.vue'),
        },
        {
            path: '/syncStates/:identifier',
            name: 'syncStatesDetail',
            component: () => import('./views/syncStatesDetail.vue'),
        },
        {
            path: '/marketplaceActivations',
            name: 'marketplaceActivations',
            component: () => import('./views/marketplaceActivations.vue'),
        },
        {
            path: '/marketplaceActivations/:identifier',
            name: 'marketplaceActivationsDetail',
            component: () => import('./views/marketplaceActivationsDetail.vue'),
        },
    ];
};